import React, { Component, ReactNode } from 'react';
import { Typography } from '@cars4ever/public-ui';

import { logger } from '@digital-dealer/utils';
import { textsService } from '@digital-dealer/texts-service';
import { ServerDownIcon } from '@digital-dealer/icons';

import styles from './styles.module.scss';

const title = textsService.get('common.error.serverDown');
const subTitle = textsService.get('common.error.tryReload');

export interface IErrorBoundaryProps {
  onCatch?: () => void;
  children?: ReactNode;
}

interface IErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  public state: IErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): IErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public componentDidCatch(error: Error, info: Record<string, any>): void {
    logger.trackCriticalError(error, {
      info,
      catcher: 'ErrorBoundary',
    });

    const { onCatch } = this.props;

    if (typeof onCatch === 'function') {
      onCatch();

      this.setState((): IErrorBoundaryState => ({
        hasError: false,
      }));
    }
  }

  public render(): ReactNode {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <ServerDownIcon className={styles.icon}/>
            <Typography
              variant="h1"
              className={styles.title}
            >
              {title}
            </Typography>
            <Typography
              variant="caption1"
              className={styles.subTitle}
            >
              {subTitle}
            </Typography>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
